module.exports = __webpack_public_path__ + "static/media/go-read-qr-code.48197c3d.svg";